import React, {useState, useEffect} from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import axios from 'axios';
import express from 'express';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import sadas from '../assets/images/sadas.png';

function Main() {
/*  const express = require("express")
  const app = express()
  const cors = require("cors")
  const headers = {
    'Access-Control-Allow-Origin': '*'
  };
  const [totalReactPackages, setTotalReactPackages] = useState(null);

  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch('https://xkcd.com/info.0.json', { headers })
        .then(response => response.json())
        .then(data => setTotalReactPackages(data.alt));
  
  // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);*/
  

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={sadas} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/gakarod" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/vaibhav-anand-04079b160/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Vaibhav Anand</h1>
          <p>Full Stack Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/gakarod" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/vaibhav-anand-04079b160/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;